export default {
    name: 'mine',
    path: '',
    component: () => import('./Root.vue')
}